import React from 'react';
import { Typography } from '@mui/material';
import theme from 'theme';
import { FRContentTitleProps } from './FRContentTitle.props';

const FRContentTitle = ({ children }: FRContentTitleProps) => (
  <Typography
    style={{
      fontWeight: 700,
      fontSize: '1.125rem',
      color: theme.palette.black,
    }}
    gutterBottom>
    {children}
  </Typography>
);

export default FRContentTitle;
